import { Spin } from 'antd';
import React from 'react';

const Loading = () => {
  return (
    <div
      style={{
        zIndex: 999999,
        position: 'fixed',
        inset: 0, // ครอบเต็มจอ
        backgroundColor: 'rgba(255, 255, 255, 0.55)', // ขาวโปร่งใส
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
      }}
    >
      <Spin size="large" />
    </div>
  );
};

export default Loading;
